import React from 'react';
import Modal from '../base/Modal/Modal';
import Button from '../base/Button/Button';
import CloseIconButton from '../base/Button/Icons/CloseIconButton/CloseIconButton';
import classes from './ConfirmModalPopup.scss';

interface IConfirmModalPopup {
  openModalPopup: boolean;
  text: string;
  // buttonColor: string;
  confirmButtonText: string;
  cancelButtonText: string;
  className?: string;
  action: () => Promise<any>;
  confirmationCallback: (message?: string) => void;
  cancelCallback: () => void;
}

const ConfirmModalPopup: React.FC<IConfirmModalPopup> = ({
  openModalPopup = false,
  text,
  // buttonColor,
  confirmButtonText,
  cancelButtonText,
  className = '',
  action,
  confirmationCallback,
  cancelCallback,
}) => {
  const confirm = () => {
    action()
      .then(() => {
        confirmationCallback();
      })
      .catch((err) => {
        confirmationCallback(err);
      });
  };

  return (
    <Modal
      show={openModalPopup}
      backdropClick={() => {
        cancelCallback();
      }}
      className={className}
    >
      <div className="row center">
        <div className={classes.closeIcon}>
          <CloseIconButton className="w-6 h-6" fill="#2B2B33" clicked={cancelCallback} />
        </div>
        <div className="col col12">
          <span>{text}</span>
        </div>
        <div className={`${classes.buttonContainer} col col12 mt3 mb0`}>
          <Button color="primary" className={classes.confirmButton} text={confirmButtonText} onClick={confirm} />
          <Button
            color="primary"
            className={classes.cancelButton}
            text={cancelButtonText}
            onClick={() => {
              cancelCallback();
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModalPopup;
